import React from 'react';
import { Target, Dumbbell, Scale, Heart, Utensils, Syringe } from 'lucide-react';

const GOALS = [
  { id: 'lose_weight', label: 'Lose Weight', icon: Scale, desc: 'Reduce body fat while maintaining muscle' },
  { id: 'gain_muscle', label: 'Gain Muscle', icon: Dumbbell, desc: 'Build lean mass with proper nutrition' },
  { id: 'maintain', label: 'Maintain', icon: Heart, desc: 'Stay at your current weight and body composition' },
  { id: 'improve_nutrition', label: 'Improve Nutrition', icon: Utensils, desc: 'Focus on food quality and balanced macros' },
];

export const GoalStep = ({ formData, setFormData }) => (
  <>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {GOALS.map(g => (
        <button
          key={g.id}
          data-testid={`goal-${g.id}`}
          onClick={() => setFormData(p => ({ ...p, goal: g.id }))}
          className={`p-6 rounded-2xl text-left transition-all border-2 ${
            formData.goal === g.id
              ? 'border-[#1A3A4A] dark:border-[#6B9E8A] bg-[#1A3A4A]/5 dark:bg-[#6B9E8A]/10'
              : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 hover:border-[#1A3A4A]/20'
          } shadow-sm`}
        >
          <g.icon className={`w-8 h-8 mb-3 ${formData.goal === g.id ? 'text-[#1A3A4A] dark:text-[#6B9E8A]' : 'text-[#7A7A72]'}`} />
          <h3 className="font-semibold text-[#1A3A4A] dark:text-[#F0EDE8]">{g.label}</h3>
          <p className="text-sm text-[#7A7A72] dark:text-[#A1A1AA] mt-1">{g.desc}</p>
        </button>
      ))}
    </div>
    <button
      data-testid="glp1-link"
      onClick={() => setFormData(p => ({ ...p, glp1_enabled: true }))}
      className={`w-full mt-4 p-3 rounded-xl text-center text-sm transition-all ${
        formData.glp1_enabled
          ? 'bg-[#6B9E8A]/15 text-[#6B9E8A] font-semibold'
          : 'text-[#7A7A72] hover:text-[#1A3A4A] dark:hover:text-[#6B9E8A] hover:bg-[#1A3A4A]/5'
      }`}
    >
      <Syringe className="w-4 h-4 inline mr-1.5 -mt-0.5" />
      {formData.glp1_enabled ? 'GLP-1 mode enabled' : 'On a GLP-1 medication? Tap here.'}
    </button>
  </>
);
